module.exports = __webpack_public_path__ + "static/media/cvcTip.5a882655.jpeg";